// localStorage keys used across the app. Centralized so a key is never typed twice —
// and never hardcoded inline in a service/component.
export enum ELocalStorage {
    // The platform API-user token, sent as x-am-authorization — required on EVERY
    // secured request regardless of authProviders (see auth.interceptor.ts).
    API_TOKEN = 'shekhawat_api_token',
    // The DB-auth end-user (staff login) token, sent as x-am-user-authorization.
    ACCESS_TOKEN = 'shekhawat_access_token',
    REFRESH_TOKEN = 'shekhawat_refresh_token',
    STAFF_USER = 'shekhawat_staff_user',
    THEME = 'shekhawat_theme',
}
